/** React libraries */
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, ListGroup, Row, Spinner } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import { IoMdSend } from 'react-icons/io'

/** Custom components types, services */
import { messageService, ActivityData, MessageConstants } from "../../messageService";
import { dateConversion } from "../../../../utils/dateHandler";
import { RequestMetadaContext } from "../../logoRequest.Type";

/**  Style */
import "./style.css";
import { IconBaseProps } from "react-icons";

const LogoRequestDiscussion: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isMessageSubmitting, setIsMessageSubmitting] = useState(false);
  const [messageList, setMessageList] = useState<ActivityData[]>([]);
  const { register, getValues } = useFormContext();
  const [getCommentMessage, setCommentMessage] = useState<string>("");
  const requestMetadaContext = useContext(RequestMetadaContext);
  const isReadOnly = !requestMetadaContext.isMessageEnabled;

  const CommentSubmit = IoMdSend as React.ComponentType<IconBaseProps>;

  /**
   * Fetch messages for logo requests
   */
  const fetchMessages = async () => {
    try {
      setIsLoading(true);
      let activityData = await messageService.fetchActivities(requestMetadaContext.requestId);
      setMessageList(activityData);
      setIsLoading(false);
    } catch (exe) {
      setIsLoading(false);
      console.log(exe);
    }
  }

  /**
   *  UseEffect
   */
  useEffect(() => {
    fetchMessages();
  }, []);


  /**
 * handle on change
 * @param e 
 */
  const handleChange = (e: any) => {
    setCommentMessage(e.target.value);
  };

  /**
   * Submit message
   */
  const handleSubmitMessage = async () => {
    try {
      if (getCommentMessage?.trim().length == 0) {
        return;
      }
      setIsMessageSubmitting(true);
      let messageResponse = await messageService.addMessage(getCommentMessage, requestMetadaContext.requestId);
      if (messageResponse) {
        let succMessage = MessageConstants.COMMENTS_SUCCEESSFULL_ADDED_MSG;
        toast.success(succMessage);
        setCommentMessage("");
        fetchMessages();
      } else {
        let errorMessage = MessageConstants.COMMENTS_ADDED_FAIL_MSG;
        toast.error(errorMessage);
      }
      setIsMessageSubmitting(false);
    } catch (exe) {
      console.log(exe);
      let errorMessage = MessageConstants.COMMENTS_ADDED_FAIL_MSG;
      toast.error(errorMessage);
      setIsMessageSubmitting(false);
    }
  }

  return (
    <div className="activity-container rounded-3 p-3">
      {messageList.length === 0 && <>
        <div className="d-flex justify-content-center align-items-top pt-2 loader-section" >
          {isLoading && <>
            <p className="text-center">Loading, please wait...</p>
          </>}
          {!isLoading && <>
            <div className="text-muted text-center py-3">
              No discussion threads yet.  { !isReadOnly && <strong>Start the discussion.</strong> }
            </div>
          </>}
        </div>
      </>}
      {messageList.length > 0 && <>
        <div className="activity-timeline">
          {isLoading && <>
            <div className="d-flex justify-content-center align-items-top pt-2" >
              <p className="text-center">Loading, please wait...</p>
            </div>
          </>}
          <div className="timeline-line"></div>
          <ListGroup className="activityContent">
            {messageList.map((activity, index) => (
              <div key={activity.id} className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}>
                <span className="timeline-point"></span>
                <ListGroup.Item className="activityUser-heading-action rounded-3">
                  <div className="">
                      <strong>{activity.sharedBy.replace(/^Auditor:\s*/, "")}</strong>
                  <span className="activity-timestamp">
                    {dateConversion(activity.lastModifiedDate, "MMMM d, yyyy")}
                  </span>
                  </div>
                  {activity.description && (
                    <p
                      className="activity-heading-sublabel pt-1"
                      dangerouslySetInnerHTML={{
                        __html: new DOMParser()
                          .parseFromString(activity.description, "text/html")
                          .documentElement.textContent // Decodes all entities safely
                          ?.replace(/“|”/g, '"') // Convert fancy quotes to standard quotes
                          ?.replace(/‘|’/g, "'") || "", // Convert fancy apostrophes to standard
                      }}
                    ></p>

                  )}
                </ListGroup.Item>
              </div>
            ))}
          </ListGroup>
        </div>
      </>}
      {!isReadOnly && <>
        <hr className="mx-3  mb-3 d-none"></hr>
        <div className="comment-box-container rounded-3">
          <textarea
            className="form-control p-2 comment-box"
            placeholder="Add a Comment..."
            rows={4}
            value={getCommentMessage}
            onChange={handleChange}
            readOnly = {isMessageSubmitting}
          />

          <button type="button" disabled={isMessageSubmitting} className="send-btn" title="Send" onClick={handleSubmitMessage}>
            {isMessageSubmitting ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <CommentSubmit size={18} />
            )}
          </button>
        </div>
      </>
      }
    </div>
  );
};

export default LogoRequestDiscussion;
